export enum ProductType {
	MONO_PHASE_ANALYZER = 1,
	TRI_PHASE_ANALYZER = 2,
	MONO_PHASE_WALLBOX = 3,
	THREE_PHASE_WALLBOX = 4,
	HUB = 5,
}
